<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<ng-container *ngIf="!isMobile; else mobileView">
  <div class="cs-documents background-color-white w-100">
    <div class="cs-documents--container background-color-white w-100"
      [style.height.px]="utils.getModalHeight('ion-modal--height', 8)">
      <cs-document-header [isMobile]="isMobile" [KYC]="KYC" [verificationOptions]="verificationOptions"
        [verificationLiterals]="verificationLiterals" (verificationOption)="getVerificationOptionSelected($event)">
      </cs-document-header>
      <div *ngIf="utils.isSpain() || utils.isColombia()">
        <ng-container *ngIf="documentVerificationAvailable && isLoading">
          <div class="cs-document-item--container p-3 justify-center">
            <ion-spinner></ion-spinner>
          </div>
        </ng-container>
        <ng-container *ngIf="documentVerificationAvailable && !isLoading">
          <div class="cs-document-item--container p-3 justify-center"
            *ngIf="showStatus() && verificationOptionSelected.type === verificationType.DNI">
            <div class="warning status">
              <img [src]="getIcon()" />
              <span [ngClass]="KYC.verified">{{ getWarningMessage() }}</span>
            </div>
          </div>
          <div [hidden]="isVerificationCompleted" *ngIf="IsESorCOAndVeridasActive()">
            <div [hidden]="isManualUploadEnabled()" class="color-secondary verification-info-link"
              [ngClass]="{'p-1' : showStatus()}"></div>
            <div class="cs-documents--info red-txt p-1"
              *ngIf="globalVars?.licenseType == licenseType.Panama && globalVars?.openFromRegister">
              <a class="red-txt"><span>{{ 'registropacashierdocuments' | translate }}</span></a>
            </div>
            <div class="cs-document-item--container justify-center" [ngClass]="{'p-1' : showStatus()}"
              *ngIf="!isVerificationCompleted && verificationOptionSelected.type === verificationType.DNI">
              <div *ngIf="showVeridasButton()">
                <button [hidden]="isManualUploadEnabled() || isIOSWorkaround"
                  class="cs-document-item--btn verification-button" [disabled]="verificationStartButtonDisabled"
                  (click)="initVerification($event)">
                  <span class="color-light">{{ 'verification_start' | translate }}</span>
                </button>
                <button [hidden]="!isIOSWorkaround" class="cs-document-item--btn verification-button"
                  (click)="startWorkaround($event)" [ngClass]="{'hidden' : verificationStartButtonDisabled }">
                  <span class="color-light">{{ 'verification_start' | translate }}</span>
                </button>
                <div [hidden]="!isIOSWorkaround" *ngIf="verificationStartButtonDisabled">
                  <span>{{ 'updateVerificationStatusDesktop' | translate }} </span>
                  <i (click)="refreshWorkaround($event)"
                    class="codere-icon icon-reload cs-document-item--btn verification-button color-light"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="cs-documents--list" *ngIf="isManualUploadEnabled()">
            <ng-container *ngIf="!isMaxFailuresNumberReached()">
              <ng-container *ngIf="verificationOptionSelected.type == verificationType.DNI">
                <cs-document-item [document]="titleIDCard(this.verDocType.titleCardFront)"
                  (navigate)="triggerClick(inputOne)" [doc]="getLastDocumentUploadRequests(this.verDocType.idFront)">
                  <input id="inputDNIFront" #inputOne [type]="inputType.file" [accept]="inputFilesAccepted.images" />
                </cs-document-item>

                <cs-document-item [document]="titleIDCard(this.verDocType.titleCardReverse)"
                  (navigate)="triggerClick(inputTwo)" [doc]="getLastDocumentUploadRequests(this.verDocType.idReverse)">
                  <input id="inputDNIBack" #inputTwo [type]="inputType.file" [accept]="inputFilesAccepted.images" />
                </cs-document-item>

                <cs-document-item [document]="setSelfieLiteral()" (navigate)="triggerClick(inputFive)"
                  [doc]="getLastDocumentUploadRequests(this.verDocType.idSelfie)" iconName="verification_type_selfie">
                  <input id="inputSelfie" #inputFive [type]="inputType.file" [accept]="inputFilesAccepted.images" />
                </cs-document-item>
              </ng-container>
            </ng-container>
          </div>
          <div class="cs-documents--list">
            <ng-container *ngIf="verificationOptionSelected.type == verificationType.BankReceipt">
              <cs-document-item [document]="bankDataInfo()" (navigate)="triggerClick(inputThree)"
                [doc]="getLastDocumentUploadRequests(this.verDocType.idBank)">
                <input id="inputBankData" #inputThree [type]="inputType.file" [accept]="inputFilesAccepted.images" />
              </cs-document-item>
            </ng-container>
            <ng-container *ngIf="verificationOptionSelected.type == verificationType.Others">
              <cs-document-item [document]="otherDocument()" (navigate)="triggerClick(inputSeven)"
                [doc]="getLastDocumentUploadRequests(this.verDocType.idOther)">
                <input id="inputOthers" #inputSeven [type]="inputType.file" [accept]="inputFilesAccepted.images" />
              </cs-document-item>
              <cs-document-item *ngIf="showOriginFunds()" [document]="originFundsCheck()" [isOriginFunds]="true"
                [originFunds]="originFunds" (navigate)="openModalSworm()">
              </cs-document-item>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <!-- Other Regions -->
      <div *ngIf="!utils.isSpain() && !utils.isColombia()">
        <div class="cs-documents--info red-txt p-1"
          *ngIf="globalVars?.licenseType == licenseType.Panama && globalVars?.openFromRegister">
          <a class="red-txt"><span>{{ 'registropacashierdocuments' | translate }}</span></a>
        </div>
        <div class="cs-documents--list">
          <ng-container *ngIf="verificationOptionSelected.type == verificationType.DNI">
            <ng-container *ngIf="(veridas_NotES_NotCO_Active && canShowVeridas_NotES_NotCO)">
              <cs-document-item [document]="titleIDCard()" [verificationType]="true" tappable (click)="showInfoAlert()">
              </cs-document-item>
              <cs-verification-item *ngFor="let doc of veridasData$ | async" [doc]="doc"></cs-verification-item>
            </ng-container>

            <cs-document-item [hidden]="(veridas_NotES_NotCO_Active && canShowVeridas_NotES_NotCO)"
              [document]="titleIDCard(this.verDocType.titleCardFront)"
              [doc]="getLastDocumentUploadRequests(this.verDocType.idFront)" (navigate)="triggerClick(inputOne)">
              <input id="inputDNIFront" #inputOne [type]="inputType.file" [accept]="inputFilesAccepted.images" />
            </cs-document-item>

            <cs-document-item [hidden]="(veridas_NotES_NotCO_Active && canShowVeridas_NotES_NotCO)"
              [document]="titleIDCard(this.verDocType.titleCardReverse)"
              [doc]="getLastDocumentUploadRequests(this.verDocType.idReverse)" (navigate)="triggerClick(inputTwo)">
              <input id="inputDNIBack" #inputTwo [type]="inputType.file" [accept]="inputFilesAccepted.images" />
            </cs-document-item>

            <cs-document-item [hidden]="!globalVars?.FEATURES?.selfieDocEnabled" [document]="setSelfieLiteral()"
              [doc]="getLastDocumentUploadRequests(this.verDocType.idSelfie)" iconName="verification_type_selfie"
              (navigate)="triggerClick(inputFive)">
              <input id="inputSelfie" #inputFive [type]="inputType.file" [accept]="inputFilesAccepted.images" />
            </cs-document-item>
          </ng-container>

          <ng-container *ngIf="verificationOptionSelected.type == verificationType.BankReceipt">
            <cs-document-item [document]="bankDataInfo()" (navigate)="triggerClick(inputThree)"
              [doc]="getLastDocumentUploadRequests(this.verDocType.idBank)">
              <input id="inputBankData" #inputThree [type]="inputType.file" [accept]="inputFilesAccepted.images" />
            </cs-document-item>
          </ng-container>

          <ng-container *ngIf="verificationOptionSelected.type == verificationType.Others">
            <cs-document-item [document]="otherDocument()" (navigate)="triggerClick(inputSeven)"
              [doc]="getLastDocumentUploadRequests(this.verDocType.idOther)">
              <input id="inputOthers" #inputSeven [type]="inputType.file" [accept]="inputFilesAccepted.images" />
            </cs-document-item>
            <cs-document-item *ngIf="showOriginFunds()" [document]="originFundsCheck()" [isOriginFunds]="true"
              [originFunds]="originFunds" (navigate)="openModalSworm()">
            </cs-document-item>
          </ng-container>
        </div>
      </div>
      <div>
        <cs-documents-accordion [verificationOptionSelected]="verificationOptionSelected"
          [verificationLiterals]="verificationLiterals" [KYC]="KYC"></cs-documents-accordion>
        <cs-documents-accordion [verificationLiterals]="verificationLiterals" [isFAQ]="true"></cs-documents-accordion>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #mobileView>
  <div class="cs-documents background-color-white w-100">
    <div class="cs-documents--container background-color-white w-100">
      <cs-document-header [isMobile]="isMobile" [KYC]="KYC" [verificationOptions]="verificationOptions"
        [verificationLiterals]="verificationLiterals"
        (verificationOption)="getVerificationOptionSelected($event)"></cs-document-header>

      <div *ngIf="utils.isSpain() || utils.isColombia()">
        <ng-container *ngIf="documentVerificationAvailable && isLoading">
          <div class="cs-document-item--container p-3 justify-center">
            <ion-spinner></ion-spinner>
          </div>
        </ng-container>
        <ng-container *ngIf="documentVerificationAvailable && !isLoading">
          <div class="cs-document-item--container p-3 justify-center"
            *ngIf="showStatus() && verificationOptionSelected.type === verificationType.DNI">
            <div class="warning status">
              <img [src]="getIcon()" />
              <span [ngClass]="KYC.verified">{{ getWarningMessage() }}</span>
            </div>
          </div>
          <div [hidden]="isVerificationCompleted" *ngIf="IsESorCOAndVeridasActive()">
            <div *ngIf="!isVerificationCompleted" [hidden]="isManualUploadEnabled()"
              class="color-secondary verification-info-link" [ngClass]="{'p-1' : showStatus()}"></div>
            <div class="cs-documents--info red-txt p-1"
              *ngIf="globalVars?.licenseType == licenseType.Panama && globalVars?.openFromRegister">
              <a class="red-txt"><span>{{ 'registropacashierdocuments' | translate }}</span></a>
            </div>
            <div class="cs-document-item--container justify-center" [ngClass]="{'p-1' : showStatus()}"
              *ngIf="!isVerificationCompleted && verificationOptionSelected.type === verificationType.DNI">
              <div *ngIf="showVeridasButton()">
                <button [hidden]="isManualUploadEnabled() || isIOSWorkaround"
                  class="cs-document-item--btn verification-button" [disabled]="verificationStartButtonDisabled"
                  (click)="initVerification($event)">
                  <span class="color-light">{{ 'verification_start' | translate }}</span>
                </button>
                <button [hidden]="!isIOSWorkaround" class="cs-document-item--btn verification-button"
                  (click)="startWorkaround($event)" [ngClass]="{'hidden' : verificationStartButtonDisabled }">
                  <span class="color-light">{{ 'verification_start' | translate }}</span>
                </button>
                <div [hidden]="!isIOSWorkaround" *ngIf="verificationStartButtonDisabled">
                  <span>{{ 'updateVerificationStatusMobile' | translate }} </span>
                  <i (click)="refreshWorkaround($event)"
                    class="codere-icon icon-reload cs-document-item--btn verification-button color-light"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- TO-DO: definir la clase para spain -->
          <div class="cs-document-item--container justify-center manual-upload-title" [ngClass]="{'p-1' : showStatus()}"
            *ngIf="isManualUploadEnabled() && !utils.isColombia()">
            <span>{{ 'verification_manual_upload' | translate }}</span>
          </div>

          <!-- TO-DO: definir la clase para spain -->
          <div class="cs-documents--list" *ngIf="isManualUploadEnabled()">
            <ng-container *ngIf="!isMaxFailuresNumberReached()">
              <ng-container *ngIf="verificationOptionSelected.type == verificationType.DNI">
                <cs-document-item [document]="titleIDCard(this.verDocType.titleCardFront)"
                  (navigate)="triggerClick(inputOne)" [doc]="getLastDocumentUploadRequests(this.verDocType.idFront)">
                  <input id="inputDNIFront" #inputOne [type]="inputType.file" [accept]="inputFilesAccepted.images" />
                </cs-document-item>

                <cs-document-item [document]="titleIDCard(this.verDocType.titleCardReverse)"
                  (navigate)="triggerClick(inputTwo)" [doc]="getLastDocumentUploadRequests(this.verDocType.idReverse)">
                  <input id="inputDNIBack" #inputTwo [type]="inputType.file" [accept]="inputFilesAccepted.images" />
                </cs-document-item>

                <cs-document-item [document]="setSelfieLiteral()" (navigate)="triggerClick(inputFive)"
                  [doc]="getLastDocumentUploadRequests(this.verDocType.idSelfie)" iconName="verification_type_selfie">
                  <input id="inputSelfie" #inputFive [type]="inputType.file" [accept]="inputFilesAccepted.images" />
                </cs-document-item>
              </ng-container>
            </ng-container>
          </div>
          <div class="cs-documents--list">
            <ng-container *ngIf="verificationOptionSelected.type == verificationType.BankReceipt">
              <cs-document-item [document]="bankDataInfo()" (navigate)="triggerClick(inputThree)"
                [doc]="getLastDocumentUploadRequests(this.verDocType.idBank)">
                <input id="inputBankData" #inputThree [type]="inputType.file" [accept]="inputFilesAccepted.images" />
              </cs-document-item>
            </ng-container>

            <ng-container *ngIf="verificationOptionSelected.type == verificationType.Others">
              <cs-document-item [document]="otherDocument()" (navigate)="triggerClick(inputSeven)"
                [doc]="getLastDocumentUploadRequests(this.verDocType.idOther)">
                <input id="inputOthers" #inputSeven [type]="inputType.file" [accept]="inputFilesAccepted.images" />
              </cs-document-item>
              <cs-document-item *ngIf="showOriginFunds()" [document]="originFundsCheck()" [isOriginFunds]="true"
                [originFunds]="originFunds" (navigate)="openModalSworm()">
              </cs-document-item>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <!-- Other Regions -->
      <div *ngIf="!utils.isSpain() && !utils.isColombia()">
        <div class="cs-documents--info red-txt p-1"
          *ngIf="globalVars?.licenseType == licenseType.Panama && globalVars?.openFromRegister">
          <a class="red-txt"><span>{{ 'registropacashierdocuments' | translate }}</span></a>
        </div>
        <div class="cs-documents--list">
          <ng-container *ngIf="verificationOptionSelected.type == verificationType.DNI">
            <ng-container *ngIf="(veridas_NotES_NotCO_Active && canShowVeridas_NotES_NotCO)">
              <cs-document-item [document]="titleIDCard()" [verificationType]="true" tappable (click)="showInfoAlert()">
              </cs-document-item>
              <cs-verification-item *ngFor="let doc of veridasData$ | async" [doc]="doc"></cs-verification-item>
            </ng-container>

            <cs-document-item [hidden]="(veridas_NotES_NotCO_Active && canShowVeridas_NotES_NotCO)"
              [document]="titleIDCard(this.verDocType.titleCardFront)"
              [doc]="getLastDocumentUploadRequests(this.verDocType.idFront)" (navigate)="triggerClick(inputOne)">
              <input id="inputDNIFront" #inputOne [type]="inputType.file" [accept]="inputFilesAccepted.images" />
            </cs-document-item>

            <cs-document-item [hidden]="(veridas_NotES_NotCO_Active && canShowVeridas_NotES_NotCO)"
              [document]="titleIDCard(this.verDocType.titleCardReverse)"
              [doc]="getLastDocumentUploadRequests(this.verDocType.idReverse)" (navigate)="triggerClick(inputTwo)">
              <input id="inputDNIBack" #inputTwo [type]="inputType.file" [accept]="inputFilesAccepted.images" />
            </cs-document-item>

            <cs-document-item [hidden]="(veridas_NotES_NotCO_Active && canShowVeridas_NotES_NotCO)"
              [document]="setSelfieLiteral()" (navigate)="triggerClick(inputFive)"
              [doc]="getLastDocumentUploadRequests(this.verDocType.idSelfie)" iconName="verification_type_selfie">
              <input id="inputSelfie" #inputFive [type]="inputType.file" [accept]="inputFilesAccepted.images" />
            </cs-document-item>
          </ng-container>
        </div>
        <div class="cs-documents--list">
          <ng-container *ngIf="verificationOptionSelected.type == verificationType.BankReceipt">
            <cs-document-item [document]="bankDataInfo()" (navigate)="triggerClick(inputThree)"
              [doc]="getLastDocumentUploadRequests(this.verDocType.idBank)">
              <input id="inputBankData" #inputThree [type]="inputType.file" [accept]="inputFilesAccepted.images" />
            </cs-document-item>
          </ng-container>

          <ng-container *ngIf="verificationOptionSelected.type == verificationType.Others">
            <cs-document-item [document]="otherDocument()" (navigate)="triggerClick(inputSeven)"
              [doc]="getLastDocumentUploadRequests(this.verDocType.idOther)">
              <input id="inputOthers" #inputSeven [type]="inputType.file" [accept]="inputFilesAccepted.images" />
            </cs-document-item>
            <cs-document-item *ngIf="showOriginFunds()" [document]="originFundsCheck()" [isOriginFunds]="true"
              [originFunds]="originFunds" (navigate)="openModalSworm()">
            </cs-document-item>
          </ng-container>
        </div>
      </div>
      <div>
        <cs-documents-accordion [verificationOptionSelected]="verificationOptionSelected"
          [verificationLiterals]="verificationLiterals" [KYC]="KYC"></cs-documents-accordion>
        <cs-documents-accordion [verificationLiterals]="verificationLiterals" [isFAQ]="true"></cs-documents-accordion>
      </div>
    </div>
  </div>
</ng-template>